import React from 'react';

import { SVGComponentProps } from './svg.types';

const UserSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M0.845215 11.949V10.943C0.863871 10.5765 0.982359 10.2221 1.18787 9.91804C1.39338 9.61401 1.67809 9.37194 2.01121 9.218C5.2129 7.93196 8.78753 7.93196 11.9892 9.218C12.3223 9.37194 12.6071 9.61401 12.8126 9.91804C13.0181 10.2221 13.1366 10.5765 13.1552 10.943V11.949C13.1551 12.2186 13.1018 12.4856 12.9984 12.7347C12.8951 12.9837 12.7436 13.2099 12.5528 13.4004C12.3619 13.5909 12.1354 13.7419 11.8862 13.8448C11.6369 13.9476 11.3699 14.0004 11.1002 14H2.90021C2.63057 14.0004 2.3635 13.9476 2.11426 13.8448C1.86502 13.7419 1.6385 13.5909 1.44765 13.4004C1.2568 13.2099 1.10536 12.9837 1.00199 12.7347C0.898619 12.4856 0.845346 12.2186 0.845215 11.949ZM7.00021 1.46266e-07C6.32376 -0.000197648 5.66244 0.200214 5.09989 0.575888C4.53734 0.951562 4.09884 1.48562 3.83983 2.11053C3.58083 2.73544 3.51296 3.42311 3.64481 4.0866C3.77666 4.75008 4.1023 5.35956 4.58056 5.83795C5.05881 6.31635 5.6682 6.64217 6.33164 6.77421C6.99508 6.90625 7.68278 6.83859 8.30776 6.57976C8.93274 6.32094 9.46693 5.88259 9.84277 5.32015C10.2186 4.75772 10.4192 4.09646 10.4192 3.42C10.4193 2.97093 10.331 2.52623 10.1592 2.1113C9.98748 1.69637 9.73566 1.31934 9.41817 1.00176C9.10067 0.684166 8.72372 0.432235 8.30884 0.260352C7.89396 0.0884683 7.44929 1.27058e-07 7.00021 1.46266e-07Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default UserSVG;
